import Zergling from '../helpers/zergling';
import { SwarmLoadingStart, SwarmLoadingDone, SwarmReceiveData } from './swarm';
import { SET_BET_HISTORY_FILTERS } from "../actions/actionTypes/";

export function UpdateHistoryBets (bets, betTypes, type) {
    /**
     * @event UpdateHistoryBets
     */
    return {
        type,
        payload: {
            bets
        },
        meta: {
            betTypes
        }
    };
}

/**
 * @name LoadBetHistory
 * @description  Load Bets history for given product and date range;
 * @param {Boolean} unsettled
 * @param {Object} options
 * @returns {Function} async action dispatcher
 */
export function LoadBetHistory (unsettled = false, options = {}) {
    let swarmDataKey = "betHistory" + (unsettled ? "_unsettled" : "_settled"),
        {from_date, to_date, time_shift, product} = options,
        request = {
            where: { 
                with_pool_bets: false,
                from_date,
                to_date,
                time_shift
            },
            product
        };

    if (unsettled) {
        request.where.outcome = 0;
    }

    return function (dispatch) {
        dispatch(SwarmLoadingStart(swarmDataKey));
        Zergling
            .get(request, "bet_history")
            .then(response => {
                dispatch(SwarmReceiveData(response, swarmDataKey));
            })
            .catch()
            .then(() => dispatch(SwarmLoadingDone(swarmDataKey)));
    };
}

/**
 * @name SetBetHistoryFilters
 * @description Append Bet History filters data;
 * @param {Object} payload
 * @returns {Object}
 */
export function SetBetHistoryFilters (payload) {
    return {
        type: SET_BET_HISTORY_FILTERS,
        payload
    };
}